import type { ReactElement, ReactNode } from 'react';
import {
  useState, createContext, useMemo, useContext,
} from 'react';

import noop from 'lodash/noop';

type ContextValue = Readonly<{
  onError: (errorMessage: string) => void;
}>;

const context = createContext<ContextValue>({
  onError: noop,
});

type Props = Readonly<{
  children: ReactNode;
}>;

const ContentErrorBoundary = ({ children }: Props): ReactElement => {

  const [hasError, setHasError] = useState(false);

  const contextValue = useMemo<ContextValue>(() => ({
    onError: () => {
      setHasError(true);
    },
  }), []);

  return (
    <context.Provider value={contextValue}>
      {hasError ? null : children}
    </context.Provider>
  );
};

export const useContentErrorBoundary = (): ContextValue => useContext(context);

export default ContentErrorBoundary;
